import {
	useContributionsPageData,
	useContributionsPageState,
} from '#src/app/pages/accountSettings/contributions/main/pageContext';

import { useCardInfo } from './hooks/useCardInfo';

type Result = ModelHookResult<
	{
		currentCardInfo: string;
		currentCardInfoKey: string;
		showUpdatePayment: boolean;
	},
	EmptyObject
>;

export function usePaymentInfo(): Result {
	const [
		{
			subscription: { paymentMethod, gateway },
			pmUpdatedAt,
		},
	] = useContributionsPageState();
	const {
		data: {
			featureConfigs: { paymentMethodsEnabledFor },
		},
	} = useContributionsPageData();

	const { currentCardInfo } = useCardInfo();

	return {
		data: {
			currentCardInfo,
			currentCardInfoKey: `${pmUpdatedAt}`,
			showUpdatePayment:
				!!paymentMethodsEnabledFor &&
				paymentMethodsEnabledFor.length > 0 &&
				paymentMethod.__typename !== 'PaymentMethodPayPal' &&
				paymentMethod.__typename !== 'PaymentMethodVenmo' &&
				paymentMethod.__typename !== 'PaymentMethodOther' &&
				gateway !== 'DLOCAL',
		},
		actions: {},
	};
}
